import React from 'react';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { P200 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { FormattedDate } from '../../formattedV2';

export const MONTHLY_BILL_DATE_FORMAT = 'DD';
export const ANNUAL_BILL_DATE_FORMAT = 'MMM DD';

export const NewBillDate = ({ entitlement, isTrial }: { entitlement: EntitlementDetails; isTrial?: boolean }) => {
  const ModifiedBillDateDialog = styled(TooltipPrimitive)`
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */
    max-width: 350px;
    padding: 16px;
  `;

  const compareBillingAnchorTimestamp = (nextBillingTimestamp: number, latestEndDate: string) => {
    const d1 = new Date(nextBillingTimestamp);
    const d2 = new Date(latestEndDate);

    //if monthly subs, then compare day
    if (entitlement?.billingFrequency === generatedTypesNew.BillingFrequency.MONTHLY) {
      if (d1.getDate() === d2.getDate()) return false;
    }
    //if annual subs, then compare day and month
    if (entitlement?.billingFrequency === generatedTypesNew.BillingFrequency.ANNUAL) {
      if (d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()) return false;
    }

    return true;
  };

  const nextBillingAnchorTimestamp = entitlement?.nextBillingTimestamp;
  const lastEndTimestamp = isTrial
    ? entitlement.subscriptionTimestamps?.lastTrialEndTimestamp
    : entitlement?.latestPeriodEndDate;
  if (
    nextBillingAnchorTimestamp &&
    lastEndTimestamp &&
    compareBillingAnchorTimestamp(parseInt(nextBillingAnchorTimestamp, 10), lastEndTimestamp)
  ) {
    let dateFormat;
    let message;

    if (entitlement.billingFrequency === generatedTypesNew.BillingFrequency.MONTHLY) {
      dateFormat = MONTHLY_BILL_DATE_FORMAT;
      message = 'month';
    } else if (entitlement.billingFrequency === generatedTypesNew.BillingFrequency.ANNUAL) {
      dateFormat = ANNUAL_BILL_DATE_FORMAT;
      message = 'year';
    }

    return (
      <div className="new-bill-date" data-testid="summary-new-bill-date-label">
        <Tooltip
          content={
            <div className="new-bill-date-dialog-content">
              A new bill date of <FormattedDate dateFormat={dateFormat} date={nextBillingAnchorTimestamp} /> of each{' '}
              {message} has been set - it will be applied from the next billing cycle.
            </div>
          }
          component={ModifiedBillDateDialog}
          position="bottom-start"
          tag="span"
        >
          <span className="new-bill-date-icon">
            <InfoIcon label="Info" size="small" primaryColor={P200} />
          </span>
        </Tooltip>
        <span className="new-bill-date-text">There’s a new bill date</span>
      </div>
    );
  }
  return null;
};
